import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "history-page"
}
const _hoisted_2 = { class: "select-city" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("定位城市")
const _hoisted_4 = {
  key: 1,
  class: "history-city"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("历史记录")
const _hoisted_6 = { class: "history-city" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("热门城市")
const _hoisted_9 = { class: "history-city" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_index_anchor = _resolveComponent("van-index-anchor")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_index_bar = _resolveComponent("van-index-bar")!

  return (_ctx.showModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_index_bar, {
            "index-list": _ctx.indexList,
            sticky: true,
            "highlight-color": "#D41446"
          }, {
            default: _withCtx(() => [
              (_ctx.currentLocaltion)
                ? (_openBlock(), _createBlock(_component_van_index_anchor, {
                    key: 0,
                    index: "定位",
                    class: "city-title"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.currentLocaltion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "city-item van-hairline--surround active",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectCity(_ctx.currentLocaltion)))
                    }, _toDisplayString(_ctx.currentLocaltion), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.historyCityList && _ctx.historyCityList.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_van_index_anchor, {
                      index: "历史",
                      class: "city-title"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyCityList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "city-item van-hairline--surround",
                          key: index,
                          onClick: ($event: any) => (_ctx.onSelectCity(item))
                        }, _toDisplayString(item), 9, _hoisted_7))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_van_index_anchor, {
                index: "热门",
                class: "city-title"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotCity, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "city-item van-hairline--surround",
                    onClick: ($event: any) => (_ctx.onSelectCity(item)),
                    key: index
                  }, _toDisplayString(item), 9, _hoisted_10))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  item
                    ? (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(_component_van_index_anchor, {
                          class: "history-line",
                          index: item.cityInitials
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item && item.cityInitials), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.citys, (city) => {
                          return (_openBlock(), _createBlock(_component_van_cell, {
                            onClick: ($event: any) => (_ctx.onSelectCity(city.name)),
                            key: city.name
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(city.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          }, 8, ["index-list"])
        ])
      ]))
    : _createCommentVNode("", true)
}